export type LinksType = {
  title: string
  link: string
  blank?: boolean
  iconName?: string
  iconComp?: JSX.Element
  onlyShowLogin?: boolean
  iconUrl?: string
}

export type NestedNavigationLinksType = {
  title: string
  links: LinksType[]
  label?: string
}

export type NavigationLinksType = {
  [key: string]: LinksType
}

const Links: NavigationLinksType = {
  PrivacyPolicy: {
    title: "מדיניות הפרטיות",
    link: "#",
    blank: true,
  },
  TermsOfUse: {
    title: "תנאי שימוש",
    link: "#",
    blank: true,
  },
  Accessibility: { title: "הצהרת נגישות", link: "/accessibility" },
  MainPage: {
    title: "עמוד ראשי",
    link: "/",
  },
  AllModels: {
    title: "לכל ההצעות",
    link: "/search",
  },
  AboutUs: {
    title: "אודות",
    link: "/about-us",
  },
  smartAgent: {
    title: "סוכן חכם",
    link: "/contact-us",
  },
  SmartAgent: {
    title: "הקפיצו לי הזדמנויות",
    link: "/contact-us",
  },
  Blog: {
    title: "בלוג",
    link: "/blog",
  },
  TermsOfPurchase: {
    title: "תקנון הרכישה",
    link: "#",
    blank: true,
  },
  TermsOfSales: {
    title: "תקנון ימי מכירות",
    link: "#",
    blank: true,
  },
  ContactUs: {
    title: "צרו קשר",
    link: "/profile",
  },
  FAQ: {
    title: "שאלות ותשובות",
    link: "/#faq",
  },
  BMW: {
    title: "BMW",
    link: "#",
  },
  NIO: {
    title: "NIO",
    link: "#",
  },
  MAZDA: {
    title: "MAZDA",
    link: "#",
  },
  MINICOOPER: {
    title: "MINI COOPER",
    link: "#",
  },
  FORD: {
    title: "FORD",
    link: "#",
  },
  BRONCO: {
    title: "BRONCO",
    link: "#",
  },
  Profile: {
    title: "צור קשר",
    link: "/profile",
  },
}

const SideDrawerMobile: NestedNavigationLinksType[] = [
  //nio header
  { title: Links.AllModels.title, links: [Links.AllModels] },
  {
    title: "חיפוש לפי מותג",
    links: [],
    label: "allModels",
  },
  { title: Links.smartAgent.title, links: [Links.smartAgent] },
  { title: Links.Blog.title, links: [Links.Blog] },
  { title: Links.Profile.title, links: [Links.Profile] },
]

const HeaderLinkListDesktop: NestedNavigationLinksType[] = [...SideDrawerMobile]

const FooterLinks: LinksType[] = [
  Links.MainPage,
  Links.AllModels,
  Links.SmartAgent,
  Links.Blog,
  Links.FAQ,
  Links.AboutUs,
  Links.Profile,
  Links.PrivacyPolicy,
  Links.TermsOfUse,
  Links.Accessibility,
  Links.TermsOfPurchase,
  Links.TermsOfSales,
]

export type FooterColumnType = {
  header: string
  links: LinksType[]
}

const FooterColumns: FooterColumnType[] = [
  { header: "ראשי", links: [Links.MainPage, Links.AllModels, Links.smartAgent] },
  { header: "תוכן ומידע", links: [Links.Blog, Links.FAQ, Links.AboutUs] },
  { header: "חשוב לדעת", links: [Links.Profile, Links.PrivacyPolicy, Links.TermsOfUse] },
  { header: "מידע נוסף", links: [Links.Accessibility, Links.TermsOfPurchase, Links.TermsOfSales] },
]

export { FooterColumns, FooterLinks, HeaderLinkListDesktop, Links, SideDrawerMobile }
